import React from 'react';
import { useEvaluationRequestUtils } from '../../../utils/useRecommendation';
import { TextParagraph } from '../../controls/Typography/TextBody';
import BaseModal from '../BaseModal';

/**
 *
 * @param {{
 *  show?:boolean;
 *  onClose?(r:boolean):void;
 *  request:import('../../../store/reducers/dashboardReducer').TEvaluationRequest;
 *  isBusy?:boolean;
 * }} props
 * @returns {React.ReactElement}
 */
export const StopReuseRecommendationModal = props => {
  const { show, onClose, request, isBusy } = props;
  const evaluation = useEvaluationRequestUtils(request);
  const evaluationName = evaluation.getEvaluationDisplayName().toSingleForm().toLowerCase();
  const applicantName = evaluation.getApplicantFullName();
  return (
    <BaseModal
      show={show}
      isBusy={isBusy}
      size="small"
      title={`Stop reusing this ${evaluationName}?`}
      body={
        <>
          <TextParagraph>
            This {evaluationName} is currently automatically reused for all requests of this type from {applicantName}.
          </TextParagraph>
          <br />
          <TextParagraph>
            If you stop reusing this {evaluationName}, you will need to manually complete each future {evaluationName}{' '}
            request from {request.applicantFirstName}.
          </TextParagraph>
        </>
      }
      modalSecondaryButton={'Back'}
      modalPrimaryButton={'Stop'}
      modalClass={'stop-reuse-recommendation-modal text-center'}
      onClose={onClose}
    />
  );
};

export default StopReuseRecommendationModal;
